import React, { Component } from 'react';
import pin from "../images/lokal/pin.png"
import whiteloc from "../images/icons/whiteloc.png"
import LokalLocation from "../lokal/lokalLocation"
import $ from "jquery";
export default class HeaderLocation extends Component {
    locationClick() {
        $(".locationPopUp").show();
    }
    render() {
        let themeId = localStorage.getItem('themeId')
        let hasLocation = localStorage.getItem('hasLocation');
        return (
            hasLocation === '1' && (localStorage.getItem('siteGlobalDelivery') !== "true")?
                <div className="locationDiv headerIcons">
                    <div onClick={this.locationClick} className="headerImage">
                        <img src={themeId === '29' ? whiteloc : pin} title="Location" alt="" />
                    </div>
                    <div className="popupWrap locationPopUp" id="locationDiv" >
                        <LokalLocation></LokalLocation>
                    </div>
                </div>
                : ''
        )
    }
}